package com.essntl.toastmanager

import org.koin.dsl.module

val toastManagerModule get() =
    module {
        single<ToastManager> { ToastManagerImpl() }
    }
